import React from "react";
import {hot} from "react-hot-loader";
import {Provider} from "react-redux";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import getStore from "./utils/getStore";
import EventsPage from "components/site/page/EventsPage";
import EventsList from "components/site/widgets/EventsList";
import EventsEventDetails from "components/site/widgets/EventsEventDetails";
import EventGroupDetails from "components/site/widgets/EventGroupDetails";
import EventCalendarDate from "components/site/widgets/EventCalendarDate";

function StaffRoot() {

    return (
        <Provider store={getStore()}>
            <BrowserRouter basename="/events/">
                <EventsPage>
                    <Switch>
                        <Route path={"/"} exact component={EventsList} />
                        <Route path={"/details/:eventId"} exact component={EventsEventDetails} />
                        <Route path={"/calendar/:date"} exact component={EventCalendarDate} />
                        <Route path={"/:eventGroupSlug"} exact component={EventGroupDetails} />
                    </Switch>
                </EventsPage>
                <ToastContainer />
            </BrowserRouter>
        </Provider>
    );
}

if (DEVELOPMENT) {
    StaffRoot = hot(module)(StaffRoot);
}

export default StaffRoot;
